import { withAccesscodeHeader } from 'api/v3/withAccesscodeHeader';

export async function apiV3ValidateAccesscode(
  channel: string,
  accesscode: string
): Promise<boolean> {
  const formData = new FormData();
  formData.set('accesscode', accesscode);

  const results = await fetch(
    `${
      import.meta.env.VITE_API_ENDPOINT
    }/v3/channels/${channel}/accesscode_validation`,
    {
      method: 'post',
      credentials: 'include',
      headers: withAccesscodeHeader(channel),

      body: formData
    }
  );

  if (results.ok) {
    return true;
  } else {
    return false;
  }
}
